export default "__VITE_ASSET__iGoJmzGh__"